import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <AppRoutes />

      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar
        closeOnClick
        pauseOnHover={false}
        draggable={false}
        theme="light"
        toastStyle={{
          fontSize: "13px",
          minHeight: "36px",
          padding: "8px 12px",
          borderRadius: "10px",
          marginTop: "70px", // aman, hanya untuk toast
        }}
      />
    </>
  );
}

export default App;
